import { confirmModalAtom } from '@/atom/modal';
import { history } from '@/utils/history';
import { useSetAtom } from 'jotai';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const useBlockBackward = ({ title, message }: { title: string; message: string }) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const setConfirmModal = useSetAtom(confirmModalAtom);

  useEffect(() => {
    const handlePopState = () => {
      const isBlocked = searchParams.get('block') === 'true';

      if (isBlocked) {
        setConfirmModal({
          visible: true,
          title,
          message,
          onClose: () => {
            setConfirmModal({ visible: false });
            router.forward();
          },
          onOuterClick: () => {
            setConfirmModal({ visible: false });
            router.forward();
          },
          onConfirm: () => {
            setConfirmModal({ visible: false });
            router.back();
          },
        });
      } else {
        setConfirmModal({ visible: false });
      }
    };

    const unlistenHistoryEvent = history?.listen(({ action }) => {
      if (action === 'POP') {
        handlePopState();
      }
    });

    return unlistenHistoryEvent;
  }, [searchParams]);

  useEffect(() => {
    // mounted 될때 block 파라미터가 있다면 /survey/who에서 뒤로가기로 오는 경우
    // 이미 router stack에 2중첩 상태이다.
    if (searchParams.get('block') !== 'true') {
      window.history.pushState(null, '', '?block=true');
    }

    return () => {
      // unmounted 될때 modal 닫기
      setConfirmModal({ visible: false });
    };
  }, []);
};

export default useBlockBackward;
